import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-json-view-lite/dist/index.css';
import { Provider } from 'react-redux';

import App from './components/shared/App';
import { store } from './store';
import './styles/library.css';

const root = ReactDOM.createRoot(document.querySelector('#root') as Element);

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
